import * as React from "react";
import { Text } from "./lib/Text";
import styles from "./PageOneHeading.module.css";

export function PageOneHeading(props: { children: string }) {
  return <Text style={styles.heading}>{props.children}</Text>;
}
